var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PopoutWrapper',{class:_vm.classNames},[_c('div',{staticClass:"ScreenSpinner__container"},[_c('Spinner',_vm._b({attrs:{"size":"large"}},'Spinner',_vm.$attrs,false))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }